var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM14.5154 23.4C13.8914 23.904 13.5554 24.528 13.5554 25.248C13.5554 26.352 14.3954 27 15.5474 27H24.6674C25.5554 27 26.2754 26.304 26.2754 25.416C26.2754 24.528 25.5554 23.808 24.6674 23.808H18.8114L21.5474 21.696C24.5234 19.392 25.9634 18 25.9634 15.192V15.144C25.9634 12 23.6594 9.96 20.1794 9.96C17.6354 9.96 16.0514 10.872 14.7074 12.432C14.4434 12.744 14.2754 13.176 14.2754 13.584C14.2754 14.52 15.0194 15.264 15.9554 15.264C16.5314 15.264 16.9634 15 17.2034 14.736C18.1394 13.728 18.8834 13.272 19.9394 13.272C21.2594 13.272 22.1954 14.04 22.1954 15.456C22.1954 16.848 21.3794 17.784 19.2914 19.488L14.5154 23.4Z",
    fill: "#4A22D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/Step2.4a59dc3f69b3a42eee3b949403528c96.svg";
export { ForwardRef as ReactComponent };